type Lang = 'en' | 'zh';

const supportingOrgs = [
  { href: 'https://www.ent-fund.org/en/', img: '/2022/images/AEF.png', alt: 'AEF' },
  { href: 'https://www.industryhk.org/en/', img: '/2022/images/FHKI.png', alt: 'FHKI' },
  { href: 'https://ghkmbayarea.org/', img: '/2022/images/gba.png', alt: 'GBA' },
  { href: 'https://www.hkna.org/', img: '/2022/images/HKNA.png', alt: 'HKNA' },
  { href: 'https://www.hkpc.org/en', img: '/2022/images/HKPC.png', alt: 'HKPC' },
  { href: 'http://www.hkrtia.org/', img: '/2022/images/RTIA.png', alt: 'RTIA' },
  { href: 'https://www.hkstp.org/', img: '/2022/images/HKSTP2.png', alt: 'HKSTP' },
  { href: 'https://cftasia.org/', img: '/2022/images/IFTA.png', alt: 'IFTA' },
  { href: 'https://www.lscm.hk/eng/', img: '/2022/images/LSCM.jpg', alt: 'LSCM' },
  { href: 'https://www.opotechnology.com/', img: '/2022/images/OPo.png', alt: 'OPo' },
  { href: 'https://www.startmeup.hk/', img: '/2022/images/SMUHK.png', alt: 'SMUHK' },
  { href: 'https://hktin.org/', img: '/2022/images/TIN.png', alt: 'TIN' },
  { href: 'https://www.acmcp.org/', img: '/2022/images/ACMCP.png', alt: 'ACMCP' },
];

export const Header2022 = ({ lang }: { lang: Lang }) => {
  const isZh = lang === 'zh';
  const base = isZh ? '/2022/zh' : '/2022';
  const nav = isZh
    ? [
        ['awards.php', '得獎類別'],
        ['judges.php', '評審'],
        ['winners.php', '得獎名單'],
        ['judges_criteria.php', '評審準則'],
        ['related_events.php', '相關活動'],
        ['highlights.php', '花絮'],
      ]
    : [
        ['awards.php', 'AWARDS CATEGORIES'],
        ['judges.php', 'JUDGES'],
        ['winners.php', 'WINNERS'],
        ['judges_criteria.php', 'JUDGES CRITERIA'],
        ['related_events.php', 'RELATED EVENTS'],
        ['highlights.php', 'HIGHLIGHTS'],
      ];

  return (
    <header>
      <div className="Header_Logo">
        <h1>
          <a href={`${base}/index.php`}>
            <img src="/2022/images/home-logo.png" alt="logo" />
          </a>
        </h1>
      </div>
      <div id="navmenu">
        <div id="menu-trigger">
          <div className="menu-icon">
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
          </div>
        </div>
        <div id="navmenuul">
          {nav.map(([path, label]) => (
            <li key={path}>
              <a href={`${base}/${path}`}>{label}</a>
            </li>
          ))}
          <li>
            <a id="Lang">{isZh ? 'English' : '中文'}</a>
          </li>
        </div>
      </div>
    </header>
  );
};

export const Intro2022 = ({ lang }: { lang: Lang }) => (
  <div className="Intro">
    <div className="background_test">
      <img src="/2022/images/KVbackgound-01.jpg" alt="bg" />
    </div>
    <div className="background_wrapper">
      <Header2022 lang={lang} />
      <section className="Hero">
        <div className="Slogan">BUILDING A SUSTAINABLE<br />SMART LIVING</div>
        <div className="Ball">
          <div className="BallWrap">
            <img src="/2022/images/waveball.gif" alt="KV-glass-ball-outside" />
            <div className="ClearBall">
              <img src="/2022/images/Mainbubble.png" alt="KV-glass" />
            </div>
          </div>
        </div>
        <div className="LeftBall">
          <img src="/2022/images/Leftbubble.png" alt="Leftbubble" />
          <svg></svg>
        </div>
        <div className="RightBall">
          <img src="/2022/images/Rightbubble.png" alt="Rightbubble" />
        </div>
      </section>
    </div>
  </div>
);

export const Footer2022 = ({ lang }: { lang: Lang }) => {
  const isZh = lang === 'zh';
  const shareUrl = encodeURIComponent(isZh ? 'https://smartcityslpa.etnet.com.hk/2022/zh' : 'https://smartcityslpa.etnet.com.hk/2022');
  return (
    <div className="footer_container">
      <div className="footer_container_left">
        <div className="footer_smartliving_logo">
          <img src="/2022/images/logo-2022.png" alt="" />
        </div>
        <div className="footer_contactUs">
          <div className="footer_contactUs_title">{isZh ? '活動查詢' : 'Contact Us'}</div>
          <div className="footer_contactUs_icon">
            <a href="tel:+852-28802978"><img src="/2022/images/phone.png" alt="" /></a>
            <a href="mailto:smartcityawards@etnet.com.hk"><img src="/2022/images/email.png" alt="" /></a>
          </div>
        </div>
        <div className="footer_shareTo">
          <div className="footer_shareTo_title">{isZh ? '分享到' : 'Share to'}</div>
          <div className="footer_shareTo_icon">
            <a href={`https://www.facebook.com/sharer.php?u=${shareUrl}`} target="_blank" rel="noreferrer"><img src="/2022/images/fb.png" alt="" /></a>
            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`} target="_blank" rel="noreferrer"><img src="/2022/images/linkedin.png" alt="" /></a>
            <a href={`https://wa.me/?text=${shareUrl}`} target="_blank" rel="noreferrer"><img src="/2022/images/whatsapp.png" alt="" /></a>
          </div>
        </div>
        <div className="disclaimer">
          {isZh ? '© 2023 經濟通有限公司 版權所有 不得轉載' : '© 2023 ET Net Limited. All rights reserved.'}
        </div>
      </div>
      <div className="footer_container_right">
        <div className="footer_organiser">
          <div className="footer_organiser_title">{isZh ? '主辦機構' : 'Organiser'}</div>
          <div className="footer_organiser_logo"><a href="http://www.etnet.com.hk" target="_blank" rel="noreferrer"><img src="/2022/images/etnet.svg" alt="" /></a></div>
        </div>
        <div className="footer_co_organiser">
          <div className="footer_co_organiser_title">{isZh ? '協辦機構' : 'Co-organiser'}</div>
          <div className="footer_co_organiser_logo"><a href="http://www.cyberport.hk/en" target="_blank" rel="noreferrer"><img src="/2022/images/cyberport.png" alt="" /></a></div>
        </div>
        <div className="footer_strategic_partners">
          <div className="footer_strategic_partners_title">{isZh ? '策略夥伴' : 'Strategic Partners'}</div>
          <div className="footer_strategic_partners_logo">
            <a href="https://home.kpmg/cn/en/home.html" target="_blank" rel="noreferrer"><img src="/2022/images/kpmg.png" alt="" /></a>
            <a href="https://smartcity.org.hk/index.php/en/" target="_blank" rel="noreferrer"><img src="/2022/images/scc.png" alt="" /></a>
          </div>
        </div>
        <div className="footer_sponsor">
          <div className="footer_sponsor_title">{isZh ? '贊助機構' : 'Sponsor'}</div>
          <div className="footer_sponsor_logo"><a href="https://www.deloitte.com/global/en.html" target="_blank" rel="noreferrer"><img src="/2022/images/Deloitte.png" alt="" /></a></div>
        </div>
        <div className="footer_supporting_organiser">
          <div className="footer_supporting_organiser_title">{isZh ? '支持機構' : 'Supporting Organisations'}</div>
          <div className="footer_supporting_organiser_logo">
            {supportingOrgs.map((item) => (
              <a key={item.img} href={item.href} target="_blank" rel="noreferrer">
                <img src={item.img} alt={item.alt} />
              </a>
            ))}
            <div className="footer_supporting_organiser_remarks">
              {isZh ? '排名按字母順序排列' : 'Listed in alphabetical order'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

